import { Injectable } from "@angular/core";
import { BudgetVsActualFacadeService } from "../services/budget-vs-actual-facade.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as BudgetVsActualActions from '../actions/budget-vs-actual.actions';
import {map, mergeMap, catchError, of, concatMap, filter} from "rxjs";
import * as widgetConfigActions from "@dashboard-widget/actions/dashboard-widget-config.actions";
import {
  BudgetVsActualConfigData
} from "@feature/_app_modules/budget-vs-actual/models/budget-vs-actual-config-data.model";

@Injectable()
export class BudgetVsActualEffects {

    constructor(
        private readonly actions$: Actions,
        private readonly facadeService: BudgetVsActualFacadeService
    ) { }

    budgetDataLoad$ = createEffect(() => this.actions$.pipe(
        ofType(BudgetVsActualActions.BudgetDataLoad),
        mergeMap(action => this.facadeService.requestBudgetVsActualData(
                    action.entityKey,
                    action.propertyTaskUri,
                    action.budgetPeriodUris,
                    action.widgetId).pipe(
            map(response => BudgetVsActualActions.BudgetDataLoadComplete({
                widgetId: action.widgetId,
                data: response.Data,
                currencyCode: response.CurrencyCode,
                year: response.Year,
                propertyRef: response.PropertyRef,
                propertyName: response.PropertyName,
                unitRef: response.UnitRef
            })),
            catchError(err => of(BudgetVsActualActions.BudgetDataLoadError({
                widgetId: action.widgetId,
                error: err
            })))
        ))
    ));

    widgetConfigComplete$ = createEffect(() => this.actions$.pipe(
      ofType(widgetConfigActions.getDashboardWidgetConfigurationComplete),
      filter(x => x.config?.ConfigurationObject && "IncludeCommitments" in x.config.ConfigurationObject),
      map(x => BudgetVsActualActions.getBvAWidgetConfigComplete({
        widgetId: x.widgetId, config: x.config.ConfigurationObject })))
    );

  columnsChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BudgetVsActualActions.ColumnsChange),
      mergeMap(action =>
        this.facadeService.setSelectedColumns(action.widgetId, action.columns).pipe(
          map(() => BudgetVsActualActions.SetColumnsComplete({
            widgetId: action.widgetId
          }),
            catchError(err => of(BudgetVsActualActions.SetColumnsError({
              widgetId: action.widgetId, error: err
            })))
        )
      )
    )
  ));

  selectedColumnsLoad$ = createEffect(() => this.actions$.pipe(
    ofType(BudgetVsActualActions.SelectedColumnsLoad),
    mergeMap(action => this.facadeService.requestSelectedColumns(action.widgetId).pipe(
      map(response => BudgetVsActualActions.SelectedColumnsLoadComplete({
        widgetId: action.widgetId,
        columns: response
      })),
      catchError(err => of(BudgetVsActualActions.SelectedColumnsLoadError({
        widgetId: action.widgetId,
        error: err
      })))
    ))
  ));
}
